import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InscripcionConvenioComponent } from './inscripcion-convenio.component';



const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'inscripcionConvenio', component: InscripcionConvenioComponent, data: { titulo: 'Inscripción a Convenio' } },
      {
        path: 'inscripcionConvenio/:token',
        component: InscripcionConvenioComponent
      }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InscripcionConvenioRoutingModule { }
